export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.iframe-holder', {
      url: 'iframe',
      template: '<nets-iframe></nets-iframe>',
    });
};
